import axiosInstance from '@/api/axiosInstance';
import { DeleteQuizResponse } from './types';

/**
 * Delete a quiz
 * DELETE /api/learning-center/quizzes/:id
 * Requires ROLE_LEARNING_ADMIN or ROLE_SUPER_ADMIN
 */
export const deleteQuiz = async (id: number): Promise<DeleteQuizResponse> => {
  try {
    const response = await axiosInstance.delete<DeleteQuizResponse>(
      `/api/learning-center/quizzes/${id}`
    );
    return response.data;
  } catch (error) {
    console.error(`Error deleting quiz ${id}:`, error);
    throw error;
  }
};
